import { render, staticRenderFns } from "./TurnServer.vue?vue&type=template&id=4ce14b8a&scoped=true"
import script from "./TurnServer.vue?vue&type=script&lang=js"
export * from "./TurnServer.vue?vue&type=script&lang=js"
import style0 from "./TurnServer.vue?vue&type=style&index=0&id=4ce14b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce14b8a",
  null
  
)

export default component.exports